<template lang="html">
  <div class="toggle-input" :class="{active: custom}" @click="changeValue">
		<div class="button"></div>
  </div>
</template>

<script>
export default {
	name: 'toggle-input',
	props: ['value'],
	data () {
		return {
			custom: false
		}
	},
	mounted () {
		this.custom = this.value
	},
	methods: {
		changeValue () {
			this.custom = !this.custom
			this.$emit('change', this.custom)
		}
	},
	watch: {
		value (newVal) {
			this.custom = newVal
		}
	}
}
</script>



// WEBPACK FOOTER //
// toggle-input.vue?414af93b